import React from 'react'
import { OurAppsBreadcrumbBar } from '../../../our-apps-breadcrumb-bar'
import CallToActionSection from '../../../call-to-action-section'
import { FeatureSection } from './feature-section'
import { AboutSection } from './about-section'
import { PrincipalProductImage } from '../../../product-image/principal-product-image'

export default function Principal() {
  return (
    <>
      <OurAppsBreadcrumbBar title="Principal" productImage={<PrincipalProductImage />} />

      <AboutSection />

      <CallToActionSection />

      <FeatureSection />
    </>
  )
}
